import React from 'react';
import axios from 'axios';
import { cityForRedirectUrl } from "../../_constants"
import Geocode from "react-geocode";
import history from '../../routes/history';
import { notification } from 'antd';
import { appConstants } from '../../_constants';
import moment from 'moment-timezone';
import 'antd/dist/antd.css';

Geocode.setApiKey("AIzaSyD3NN0HjCpdHNaBtthZJgxRnMZPSJAcpSE");
Geocode.enableDebug();

class Auth extends React.Component {
    constructor(props) {
        super(props);
        this.state = { authResult: '', messageLogout: false };
        this.cityUrlFunction = this.cityUrlFunction.bind(this);
        this.showImage = this.showImage.bind(this);
        this.getAccessToken = this.getAccessToken.bind(this);
        this.callAlertMessage = this.callAlertMessage.bind(this);
        this.success = this.success.bind(this);
        this.error = this.error.bind(this);
        this.replaceString = this.replaceString.bind(this);
        this.UpperCaseName = this.UpperCaseName.bind(this);
        this.telForPhoneNumber = this.telForPhoneNumber.bind(this);
        this.telForPhoneNumberHtml = this.telForPhoneNumberHtml.bind(this);

    }

    cityUrlFunction(url) {
        if (localStorage.getItem("defaultCity") === null) {
            return url;
        } else {
            var cityName = localStorage.getItem("defaultCity").replace(/\s+/g, '');
            let urls = url ? url + "/" + cityName : "/" + cityName;
            return urls;
        }
    }

    setSession(authResult) {
        // Set the time that the access token will expire at
        let expiresAt = JSON.stringify(
            authResult.expiresIn * 5000 + new Date().getTime()
        );
        localStorage.setItem('access_token', authResult.accessToken);
        localStorage.setItem('id_token', authResult.idToken);
        localStorage.setItem('expires_at', expiresAt);
    }

    showImage(resumeImage) {
        if (resumeImage) {
            let fileUrl = process.env.REACT_APP_SERVER_IMAGE_BUCKET + '/' + resumeImage;
            return fileUrl;
        } else {
            return <span>-</span>
        }
    }

    getAccessToken() {
        let accessToken = localStorage.getItem('access_token');
        if (!accessToken) {
            history.replace('/');
        }
        return accessToken;
    }

    callAlertMessage(messageType, message) {
        if (messageType === 'success') {
            this.success(message)
        } else {
            this.error(message)
        }
    }

    success(message) {
        notification.success({
            message: message,
            className:'successNotification',
            duration: 3
        })
    }

    error(message) {
        notification.error({
            message: message,
            className:'errorNotification',
            duration: 3
        })
    }

    findTimeDiffrence = (date) => {
        if (typeof date !== 'object') {
            date = new Date(date);
        }

        var seconds = Math.floor((new Date() - date) / 1000);
        var intervalType;

        var interval = Math.floor(seconds / 31536000);
        if (interval >= 1) {
            intervalType = 'year';
        } else {
            interval = Math.floor(seconds / 2592000);
            if (interval >= 1) {
                intervalType = 'month';
            } else {
                interval = Math.floor(seconds / 86400);
                if (interval >= 1) {
                    intervalType = 'day';
                } else {
                    interval = Math.floor(seconds / 3600);
                    if (interval >= 1) {
                        intervalType = "hour";
                    } else {
                        interval = Math.floor(seconds / 60);
                        if (interval >= 1) {
                            intervalType = "minute";
                        } else {
                            interval = seconds;
                            intervalType = "second";
                        }
                    }
                }
            }
        }

        if (interval > 1 || interval === 0) {
            intervalType += 's';
        }
        return interval + ' ' + intervalType;
    };

    /*Location Dedact By Ip address*/

    getGeoInfo = () => {
        if (localStorage.getItem("defaultCity") === null) {
            var CityNameReturn = "";
            return axios.get('https://ipapi.co/json/').then((response) => {
                console.log("response", response);
                localStorage.getItem("defaultCity");
                localStorage.setItem("changeCity", false)
                localStorage.setItem("locationCountry", JSON.stringify({ label: response.data.country_name, value: response.data.country }));
                if (response.data.city) {
                    var index = cityForRedirectUrl.findIndex(userCity => cityForRedirectUrl.cityName === response.data.city)

                    if (index === -1) {
                        var setDefaultCity = { "cityName": "Los Angeles", "coordinates": [-118.2436849, 34.0522342] }
                        CityNameReturn = "Los Angeles";
                        localStorage.setItem("defaultCity", setDefaultCity.cityName);
                        localStorage.setItem("coordinate", JSON.stringify(setDefaultCity.coordinates));
                    } else {
                        CityNameReturn = response.data.city;
                        localStorage.setItem("defaultCity", response.data.city);
                        this.findCordinateOfCity(response.data.city)
                    }
                }
                return CityNameReturn ? CityNameReturn : '';
            }).catch((error) => {
                return 'error';
            });
        } else {
            this.findCordinateOfCity(localStorage.getItem("defaultCity"))
            return (localStorage.getItem("defaultCity"));
        }
    };

    /*Find corfinate of city let long*/
    findCordinateOfCity = (city) => {
        console.log("city",city)
        return Geocode.fromAddress(city).then((response) => {
                let coordinate = [];
                const { lat, lng } = response.results[0].geometry.location;
                coordinate.push(lng);
                coordinate.push(lat);
                if (localStorage.getItem("coordinate") === null) {
                    localStorage.setItem("coordinate", JSON.stringify(coordinate));
                } else {
                    return coordinate;
                }
            },
            error => {
                console.error(error);
            }
        );
    }

    randomString(length, chars) {
        let strArray = chars.split('');
        let strArrayNew = strArray;
        let smallStr = "abcdefghijklmnopqrstuvwxyz";
        let capitalStr = "ABCDEFGHIJKLMNOPQRSTUVWXYZ";
        let numberStr = "0123456789";
        let spacialStr = '~`!@#$%^&*()_+-={}[]:";\'<>?,./|\\';
        for (var i = 0; i < strArray.length; i++) {
            if (i === length) {
                if (smallStr.indexOf(strArray[i]) > -1) {
                    if (smallStr.indexOf(strArray[i]) === 25) {
                        strArrayNew[i] = smallStr.charAt(0);
                        return this.randomString(length - 1, strArrayNew.join(""));
                    } else {
                        strArrayNew[i] = smallStr.charAt(smallStr.indexOf(strArray[i]) + 1);
                    }
                } else if (capitalStr.indexOf(strArray[i]) > -1) {
                    if (capitalStr.indexOf(strArray[i]) === 25) {
                        strArrayNew[i] = capitalStr.charAt(0);
                        return this.randomString(length - 1, strArrayNew.join(""));
                    } else {
                        strArrayNew[i] = capitalStr.charAt(capitalStr.indexOf(strArray[i]) + 1);
                    }
                } else if (numberStr.indexOf(strArray[i]) > -1) {
                    if (numberStr.indexOf(strArray[i]) === 9) {
                        strArrayNew[i] = numberStr.charAt(0);
                        return this.randomString(length - 1, strArrayNew.join(""));
                    } else {
                        strArrayNew[i] = numberStr.charAt(numberStr.indexOf(strArray[i]) + 1);
                    }
                } else if (spacialStr.indexOf(strArray[i]) > -1) {
                    if (spacialStr.indexOf(strArray[i]) === 31) {
                        strArrayNew[i] = spacialStr.charAt(0);
                        return this.randomString(length - 1, strArrayNew.join(""));
                    } else {
                        strArrayNew[i] = spacialStr.charAt(spacialStr.indexOf(strArray[i]) + 1);
                    }
                }
                return strArrayNew.join('');
            }
        }
    }

    telForPhoneNumber(type, number) {
        return '<a href="tel:' + type + number + '">' + number + '</a>'
    }

    telForPhoneNumberHtml(ext, number) {
        var call = <a href={`tel:`+ext+number}>{(ext)}{number}</a>
        return call;
    }

    removeDuplicates(originalArray, prop) {
        var newArray = [];
        var lookupObject = {};

        for (var i in originalArray) {
            lookupObject[originalArray[i][prop]] = originalArray[i];
        }

        for (i in lookupObject) {
            newArray.push(lookupObject[i]);
        }
        return newArray;
    }

    replaceString(data) {
        var v = '';
        v = data.replace(/[^0-9.]/g, '').replace(/(\..*)\./g, '$1').replace(/(\d{3})(\d{3})(\d+)/, '$1-$2-$3');
        return v;
    }

    UpperCaseName(str) {
        // var splitStr = str.toLowerCase().split(' ');
        var splitStr = str.split(' ');
        for (var i = 0; i < splitStr.length; i++) {
            splitStr[i] = splitStr[i].charAt(0).toUpperCase() + splitStr[i].substring(1);
        }
        return splitStr.join(' ');
    }

    formatDate(iso_date) {
        if (typeof iso_date === 'undefined') {
            return moment().tz().format(appConstants.DATEFORMATNOTTIME);
        }
        return new Date(iso_date).toLocaleDateString("en-US");
    }

    render() {
        return '';
    }
}



export default Auth;


// WEBPACK FOOTER //
// ./src/components/Auth/auth.js